import type { IHoliday } from '~/types/date'

const YEAR_MONTH_DAY_EVENTS: IHoliday[] = [
  { date: '2024-08-11', holidayName: 'End of Paris 2024 Olympic Games' },
  { date: '2024-08-28', holidayName: 'Beginning of Paris 2024 Paralympic Games' },
  { date: '2025-03-20', holidayName: 'Spring' },
  { date: '2026-03-20', holidayName: 'Spring' },
  { date: '2027-03-20', holidayName: 'Spring' },
  { date: '2028-03-20', holidayName: 'Spring' },
  { date: '2029-03-20', holidayName: 'Spring' },
  { date: '2030-03-20', holidayName: 'Spring' },
  { date: '2025-06-21', holidayName: 'Summer' },
  { date: '2026-06-21', holidayName: 'Summer' },
  { date: '2027-06-21', holidayName: 'Summer' },
  { date: '2028-06-20', holidayName: 'Summer' },
  { date: '2029-06-21', holidayName: 'Summer' },
  { date: '2030-06-21', holidayName: 'Summer' },
  { date: '2025-09-22', holidayName: 'Autumn' },
  { date: '2026-09-23', holidayName: 'Autumn' },
  { date: '2027-09-23', holidayName: 'Autumn' },
  { date: '2028-09-22', holidayName: 'Autumn' },
  { date: '2029-09-22', holidayName: 'Autumn' },
  { date: '2030-09-22', holidayName: 'Autumn' },
  { date: '2025-12-21', holidayName: 'Winter' },
  { date: '2026-12-21', holidayName: 'Winter' },
  { date: '2027-12-22', holidayName: 'Winter' },
  { date: '2028-12-21', holidayName: 'Winter' },
  { date: '2029-12-21', holidayName: 'Winter' },
  { date: '2030-12-21', holidayName: 'Winter' },
  { date: '2025-01-29', holidayName: 'Lunar New Year' },
  { date: '2026-02-17', holidayName: 'Lunar New Year' },
  { date: '2027-02-06', holidayName: 'Lunar New Year' },
  { date: '2028-01-26', holidayName: 'Lunar New Year' },
  { date: '2029-02-13', holidayName: 'Lunar New Year' },
  { date: '2030-02-03', holidayName: 'Lunar New Year' },
  { date: '2031-01-23', holidayName: 'Lunar New Year' },
  { date: '2024-09-17', holidayName: 'Mid-Autumn Festival' },
  { date: '2025-10-06', holidayName: 'Mid-Autumn Festival' },
  { date: '2026-09-25', holidayName: 'Mid-Autumn Festival' },
  { date: '2027-09-15', holidayName: 'Mid-Autumn Festival' },
  { date: '2028-10-03', holidayName: 'Mid-Autumn Festival' },
  { date: '2029-09-22', holidayName: 'Mid-Autumn Festival' },
  { date: '2030-09-12', holidayName: 'Mid-Autumn Festival' },
  { date: '2024-11-01', holidayName: 'Diwali' },
  { date: '2025-10-21', holidayName: 'Diwali' },
  { date: '2026-11-08', holidayName: 'Diwali' },
  { date: '2027-10-29', holidayName: 'Diwali' },
  { date: '2028-10-17', holidayName: 'Diwali' },
  { date: '2029-11-05', holidayName: 'Diwali' },
  { date: '2030-10-26', holidayName: 'Diwali' },
  { date: '2024-11-28', holidayName: 'Thanksgiving' },
  { date: '2025-11-27', holidayName: 'Thanksgiving' },
  { date: '2026-11-26', holidayName: 'Thanksgiving' },
  { date: '2027-11-25', holidayName: 'Thanksgiving' },
  { date: '2028-11-23', holidayName: 'Thanksgiving' },
  { date: '2029-11-22', holidayName: 'Thanksgiving' },
  { date: '2030-11-28', holidayName: 'Thanksgiving' },
  { date: '2024-12-25', holidayName: 'Start of Hanukkah' },
  { date: '2025-12-14', holidayName: 'Start of Hanukkah' },
  { date: '2026-12-04', holidayName: 'Start of Hanukkah' },
  { date: '2027-12-24', holidayName: 'Start of Hanukkah' },
  { date: '2028-12-12', holidayName: 'Start of Hanukkah' },
  { date: '2029-12-01', holidayName: 'Start of Hanukkah' },
  { date: '2030-12-20', holidayName: 'Start of Hanukkah' },
]

const MONTH_DAY_EVENTS: IHoliday[] = [
  { date: '01-01', holidayName: "New Year's Day" },
  { date: '02-01', holidayName: 'Start of Black History Month' },
  { date: '02-14', holidayName: "Valentine's Day" },
  { date: '03-08', holidayName: "International Women's Day" },
  { date: '03-17', holidayName: "St. Patrick's Day" },
  { date: '05-01', holidayName: 'Start of Asian American and Pacific Islander (AAPI) Heritage Month' },
  { date: '06-01', holidayName: 'Start of Pride Month' },
  { date: '06-28', holidayName: 'International LGBTQIA+ Pride Day' },
  { date: '07-04', holidayName: 'Independence Day (US)' },
  { date: '08-03', holidayName: 'Color Pop anniversary' },
  { date: '10-01', holidayName: 'Start of Breast Cancer Awareness Month (Pink October)' },
  { date: '10-31', holidayName: 'Halloween' },
  { date: '11-03', holidayName: 'World Kindness Day' },
  { date: '12-06', holidayName: 'Saint Nicholas Day' },
  { date: '12-08', holidayName: 'World Climate Day' },
  { date: '12-25', holidayName: 'Christmas' },
  { date: '12-31', holidayName: "New Year's Eve" },
]

const prefixMonthDayEventsWithYear = (monthDayEvents: IHoliday[], startYear: number, endYear: number): IHoliday[] => {
  const events: IHoliday[] = []

  for (let year = startYear; year <= endYear; year++) {
    monthDayEvents.forEach((event) => {
      events.push({
        date: `${year}-${event.date}`,
        holidayName: event.holidayName,
      })
    })
  }

  return events
}

export const EVENTS = [...YEAR_MONTH_DAY_EVENTS, ...prefixMonthDayEventsWithYear(MONTH_DAY_EVENTS, 2024, 2028)]
